export default {
  method: 'get',
  // 基础url前缀
  // baseURL: '/',
  baseURL: process.env.VUE_APP_BASE_URL,
  // 请求头信息
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  // post data参数
  data: {},
  // get urlparams参数
  params: {},
  // 设置超时时间
  timeout: 30000
}
